import { Phone, MapPin, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=Via+Don+Giovanni+Beltrame+22+Valeggio+sul+Mincio';

export const MobileContactBar = () => {
  const { t } = useLanguage();
  const items = [
    { href: 'tel:+390456370799', icon: Phone, label: t('ui.mobileBar.call'), id: 'call' },
    { href: MAPS_URL, icon: MapPin, label: t('ui.mobileBar.directions'), id: 'directions', external: true },
    { href: 'mailto:info@accordinicarillo.it', icon: Mail, label: t('ui.mobileBar.email'), id: 'email' },
  ];
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#283880] border-t border-[#C9A227]/40 grid grid-cols-3 pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-contact-bar"
    >
      {items.map(({ href, icon: Icon, label, id, external }) => (
        <a
          key={id}
          href={href}
          {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          data-testid={`mobile-bar-${id}`}
          className="flex flex-col items-center justify-center gap-1 h-16 text-white active:bg-white/10 transition-colors"
        >
          <Icon className="w-5 h-5 text-[#C9A227]" />
          <span className="text-[11px] uppercase tracking-wider font-semibold">{label}</span>
        </a>
      ))}
    </nav>
  );
};
